import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "react-router-dom/es/Link";
import calculadora from "../../images/calculadora.svg";
import { MainButton } from "../../components/buttons/MainButton";
import { ContactModal } from "../../components/modals/ContactModal";
import { NewRealStateModal } from "../../components/modals/NewRealStateModal";
// import { ReclaimModal } from "../../components/modals/ReclaimModal";

export class InfoAside extends React.Component {
  render() {
    return (
      <aside className="section-aside">
        <div className="aside-block">
          <img
            src={calculadora}
            className="calculadora"
            alt="ilustración de una calculadora"
          />
          <div className="btn-list">
            <MainButton to="/requisitos" text="Requisitos" />
            <MainButton to="/calculadora" text="Calcular Costos" />
          </div>
        </div>
        <MainButton to="/inicio" text="Solicitar Garantía" />
        <div className="aside-links">
          <div className="link">
            <Link className="link-btn" to="/sucursales">
              <FontAwesomeIcon className="icon" icon="map-marker-alt" />
              <p>Oficinas Finaer</p>
            </Link>
          </div>
          <div className="link">
            <ContactModal
              class="link-btn"
              icon="envelope"
              button="¿Alguna duda? Consultanos"
            />
          </div>
          <div className="link">
            <a
              href="https://landing.finaersa.com.ar/incumplimientos"
              target="_blank"
              rel="noopener noreferrer"
              className="link-btn"
            >
              <FontAwesomeIcon className="icon" icon="clipboard-list" />
              Formulario de Incumplimiento
            </a>
          </div>
          <div className="link">
            <NewRealStateModal
              class="link-btn"
              icon="clipboard-check"
              button="Solicitud de adhesión"
            />
          </div>
          <div className="link">
            <Link className="link-btn" to="/inmobiliarias">
              <FontAwesomeIcon className="icon" icon="key" />
              <p>Inmobiliarias Adheridas</p>
            </Link>
          </div>
        </div>
      </aside>
    );
  }
}
